import { render, staticRenderFns } from "./relClientDialog.vue?vue&type=template&id=2815211d"
import script from "./relClientDialog.vue?vue&type=script&lang=js"
export * from "./relClientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports